export default __webpack_public_path__ + "static/media/about.38a9eb11.png";